import throttle from '@utility/helpers/throttle';
import { RefObject, useEffect, useState } from 'react';

const useScrolledToEnd = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
  paused?: boolean
) => {
  const [scrolledToEnd, setScrolledToEnd] = useState(false);

  const checkHasScrolledToEnd = (paused?: boolean) => {
    const element = ref?.current;
    if (!element || paused) {
      setScrolledToEnd(false);
      return;
    }

    const elementRect = element.getBoundingClientRect();

    setScrolledToEnd(Math.floor(elementRect.bottom) <= window.innerHeight);
  };

  const throttledCheckHasScrolledToEnd = throttle(() => {
    checkHasScrolledToEnd(paused);
  }, 300);

  useEffect(() => {
    window.addEventListener('scroll', throttledCheckHasScrolledToEnd);

    return () =>
      window.removeEventListener('scroll', throttledCheckHasScrolledToEnd);
  }, [checkHasScrolledToEnd]);

  return scrolledToEnd;
};

export default useScrolledToEnd;
